import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';
import { ShowIf } from 'components/utils';

class BlockBanHanhQuyetDinhView extends React.Component {
  render() {
    let DataDetail = this.props.thongTinGQD || {};
    let donInfo = this.props.donInfo || {};
    let ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(state => {
      return state.giaTri == DataDetail.ketLuanNoiDungKhieuNai
    });
    return (
      <div>
        <ShowIf condition={DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
          <ShowIf condition={donInfo.loaiDon == 'DON_TO_CAO'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định giải quyết tố cáo</h3>
          </ShowIf>
          <ShowIf condition={donInfo.loaiDon == 'DON_KHIEU_NAI'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
          </ShowIf>
          <ShowIf condition={donInfo.loaiDon != 'DON_TO_CAO' && donInfo.loaiDon != 'DON_KHIEU_NAI'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Văn bản giải quyết kiến nghị, phản ánh</h3>
          </ShowIf>

          <div className="row pl10 pr10 mb15">
            <Text className="col-25 mb0-18" label="Số vụ:" value={DataDetail.soVuGiaiQuyetKhieuNai || 0}/>
            <ShowIf condition={donInfo.loaiDon == 'DON_KHIEU_NAI'}>
              <Text label="Kết luận nội dung khiếu nại:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <ShowIf condition={donInfo.loaiDon == 'DON_TO_CAO'}>
              <Text label="Kết luận nội dung tố cáo:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <ShowIf condition={donInfo.loaiDon != 'DON_TO_CAO' && donInfo.loaiDon != 'DON_KHIEU_NAI'}>
              <Text label="Kết luận nội dung kiến nghị phản ánh:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <Text className="col-25 mb0-18" label="Kết quả khác:" value={DataDetail.ketQuaGiaiQuyetKhac ? DataDetail.ketQuaGiaiQuyetKhac : ''}/>
          </div>

          <div className="row pl10 pr10 mb5">
            <div className="col-50 no-gutter mb20">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={DataDetail.tienPhaiThuNhaNuocQDGQ || 0}/>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={DataDetail.datPhaiThuNhaNuocQDGQ || 0}/>
            </div>
            <div className="col-50 no-gutter mb20">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={DataDetail.tienPhaiTraCongDanQDGQ || 0}/>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={DataDetail.datPhaiTraCongDanQDGQ || 0}/>
            </div>
            <div className="col-100 no-gutter">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
              <Text className="col-25 mb0-18" type="sdt" label="Tổng số người:" value={DataDetail.tongSoNguoiXuLyHanhChinh || 0}/>
              <Text className="col-25 mb0-18" type="sdt" label="Số người đã bị xử lý:" value={DataDetail.soNguoiDaBiXuLyHanhChinh || 0}/>
              <Text className="col-25 mb0-18" label="Số người được trả lại quyền lợi:" value={DataDetail.soNguoiDuocTraLaiQuyenLoi || 0}/>
            </div>
          </div>
          <ShowIf condition={DataDetail.giaoCoQuanDieuTra}>
            <div className="row pl15 pr15 mb5">
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb0-18" label="Tên cơ quan:" value={DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : ''}/>
                  <Text className="col-25 mb0-18" label="Số vụ:" value={DataDetail.soVuGiaoCoQuanDieuTra || 0}/>
                  <Text className="col-25 mb0-18" label="Số đối tượng:" value={DataDetail.soDoiTuongGiaoCoQuanDieuTra || 0}/>
                </div>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={DataDetail.khoiTo}>
            <div className="row pl15 pr15 mb5">
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-12 mb15">Khởi tố</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <Text className="col-50 mb0-18" label="Số vụ:" value={DataDetail.soVuBiKhoiTo || 0}/>
                    <Text className="col-50 mb0-18" label="Số đối tượng:" value={DataDetail.soDoiTuongBiKhoiTo || 0}/>
                  </div>
                </div>
              </div>
            </div>
          </ShowIf>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={DataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
          <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định đình chỉ</h3>
          <Text className="col-25 pl0 mb10" label="Số văn bản:" value={DataDetail.soVanBan || ''}/>
          <Text className="col-25 mb10" label="Ngày ban hành:" value={DataDetail.ngayBanHanh ? moment(DataDetail.ngayBanHanh).format('DD/MM/YYYY') : ''}/>
          <Text className="col-25 mb10" label="Người ký:" value={DataDetail.nguoiBanHanhInfo ? DataDetail.nguoiBanHanhInfo.hoVaTen : ''}/>
          <TextMessage className='col-100 pl0 mb15' label='Lý do đình chỉ:' value={DataDetail.lyDoBanHanhQuyetDinhDinhChi || ''}/>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
      </div>
    );
  }
}

BlockBanHanhQuyetDinhView.defaultProps = {
  donInfo: {},
  thongTinGQD: {}
}

export default BlockBanHanhQuyetDinhView;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/BlockBanHanhQuyetDinhView.jsx